import { observable } from "mobx";
import { Expose } from "class-transformer";
import type { EntityValidationRules } from "services/validation/entityValidationRules";

export default class UpdateLoginEmail {
  @observable
  email!: string;

  static ValidationRules = {
    email: { required: true },
  };
}

export class ExtendUpdateLoginEmail extends UpdateLoginEmail {
  @observable
  @Expose({ name: "email_confirmation" })
  emailConfirmation?: string;
  @observable
  @Expose({ name: "email_current" })
  emailCurrent?: string;
}

export class RspUpdateLoginEmail {
  @observable
  @Expose({ name: "sap_notice" })
  sapNotice?: string;

  @observable
  email: string;
}

const UpdateLoginEmailValidationRules: EntityValidationRules<ExtendUpdateLoginEmail> = {
  email: { required: true, isEmail: true },
  emailConfirmation: {
    required: true,
    equalWith: { parameter: "email", translationCode: "validators.email_confirmation_mismatch" },
  },
  emailCurrent: { required: true, isEmail: true },
};
export { UpdateLoginEmailValidationRules };
